import { LastInteraction } from '../utils/interaction.js';
import { objectEntries } from '../utils/object.js';

/**
 * Helper to safely cast a value to a branded type; the compiler will ensure that all
 * other properties are satisfied before casting.
 */
function brand(value) {
    return value;
}
function managerControlsActiveElement(manager) {
    return !!document.activeElement?.closest(`[data-tab-group="${CSS.escape(manager.tabGroupId)}"]`);
}
function firstActiveTab(tabIds) {
    for (const [key, val] of objectEntries(tabIds)) {
        if (val)
            return key;
    }
    throw new Error('There must always be at least one active tab');
}
function getActiveTabs(tabIds) {
    return objectEntries(tabIds).reduce((acc, [key, val]) => {
        if (val)
            acc.push(key);
        return acc;
    }, []);
}
const TAB_SWITCHING_KEYS = new Set([
    'ArrowUp',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight',
    'Home',
    'End',
]);
function focusTabInGroup(tabGroupId, tabId) {
    const tabEl = document.getElementById(getTriggerId(tabGroupId, tabId));
    tabEl?.focus();
    if (TAB_SWITCHING_KEYS.has(LastInteraction.key)) {
        // If we are focusing this tab due to the keyboard, then we want to make sure the tab maintains
        // its focus, even if a child of the tab has autoFocus set on it.
        queueMicrotask(() => tabEl?.focus());
    }
}
function getTriggerId(tabGroupId, id) {
    return `tab${tabGroupId}-${id}-trigger`;
}
function getPanelId(tabGroupId, id) {
    return `tab${tabGroupId}-${id}-panel`;
}

export { brand, firstActiveTab, focusTabInGroup, getActiveTabs, getPanelId, getTriggerId, managerControlsActiveElement };
//# sourceMappingURL=tabs-primitive.utils.js.map
